import development from "./config_uat";
import production from "./config_sass";

// 配置config
if (process.env.NODE_ENV === "production") {
  if (process.env.VUE_APP_FLAG === "pro") {
    window.$config = production;
  } else {
    window.$config = production;
  }
} else {
  window.$config = production;
}

export default window.$config